import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-241c23ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workouts-filters" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-items-group" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-items-group" }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-items-group" }
const _hoisted_15 = { class: "form-item" }
const _hoisted_16 = { class: "form-inputs-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-items-group" }
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = { class: "form-inputs-group" }
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-items-group" }
const _hoisted_25 = { class: "form-item" }
const _hoisted_26 = { class: "form-inputs-group" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-items-group" }
const _hoisted_30 = { class: "form-item" }
const _hoisted_31 = { class: "form-inputs-group" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "form-button" }

import { ComputedRef, computed, toRefs, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { LocationQuery, useRoute, useRouter } from 'vue-router'

  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { translateSports } from '@/utils/sports'
  import { units } from '@/utils/units'

  interface Props {
    authUser: IUserProfile
    sports: ISport[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    authUser: null,
    sports: null
  },
  emits: ['filter'],
  setup(__props: any, { emit }) {

const props = __props as {
    authUser: IUserProfile
    sports: ISport[]
  }

  

  

  const { t } = useI18n()
  const route = useRoute()
  const router = useRouter()

  const { authUser } = toRefs(props)

  const toUnit = authUser.value.imperial_units
    ? units['km'].defaultTarget
    : 'km'
  const translatedSports: ComputedRef<ISport[]> = computed(() =>
    translateSports(props.sports, t)
  )
  let params: LocationQuery = Object.assign({}, route.query)

  function handleFilterChange(event: Event & { target: HTMLInputElement }) {
    if (event.target.value === '') {
      delete params[event.target.name]
    } else {
      params[event.target.name] = event.target.value
    }
  }
  function onFilter() {
    emit('filter')
    if ('page' in params) {
      params['page'] = '1'
    }
    router.push({ path: '/workouts', query: params })
  }
  function onClearFilter() {
    emit('filter')
    router.push({ path: '/workouts', query: {} })
  }

  watch(
    () => route.query,
    (newQuery) => {
      params = Object.assign({}, newQuery)
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.FROM')) + ": ", 1),
            _createElementVNode("input", {
              name: "from",
              type: "date",
              value: _ctx.$route.query.from,
              onChange: handleFilterChange
            }, null, 40, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.TO')) + ": ", 1),
            _createElementVNode("input", {
              name: "to",
              type: "date",
              value: _ctx.$route.query.to,
              onChange: handleFilterChange
            }, null, 40, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.SPORT', 1)) + ":", 1),
            _createElementVNode("select", {
              name: "sport_id",
              value: _ctx.$route.query.sport_id,
              onChange: handleFilterChange
            }, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(translatedSports).filter((s) =>
                  _unref(authUser).sports_list.includes(s.id)
                ), (sport) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: sport.id,
                  key: sport.id
                }, _toDisplayString(sport.translatedLabel), 9, _hoisted_13))
              }), 128))
            ], 40, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.DISTANCE')) + " (" + _toDisplayString(_unref(toUnit)) + "): ", 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("input", {
                name: "distance_from",
                type: "number",
                min: "0",
                step: "0.1",
                value: _ctx.$route.query.distance_from,
                onChange: handleFilterChange
              }, null, 40, _hoisted_17),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('workouts.TO')), 1),
              _createElementVNode("input", {
                name: "distance_to",
                type: "number",
                min: "0",
                step: "0.1",
                value: _ctx.$route.query.distance_to,
                onChange: handleFilterChange
              }, null, 40, _hoisted_18)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.DURATION')) + ": ", 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                name: "duration_from",
                value: _ctx.$route.query.duration_from,
                onChange: handleFilterChange,
                pattern: "^([0-9]*[0-9]):([0-5][0-9])$",
                placeholder: "hh:mm",
                type: "text"
              }, null, 40, _hoisted_22),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('workouts.TO')), 1),
              _createElementVNode("input", {
                name: "duration_to",
                value: _ctx.$route.query.duration_to,
                onChange: handleFilterChange,
                pattern: "^([0-9]*[0-9]):([0-5][0-9])$",
                placeholder: "hh:mm",
                type: "text"
              }, null, 40, _hoisted_23)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.AVE_SPEED')) + " (" + _toDisplayString(_unref(toUnit)) + "/h): ", 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("input", {
                min: "0",
                name: "ave_speed_from",
                value: _ctx.$route.query.ave_speed_from,
                onChange: handleFilterChange,
                step: "0.1",
                type: "number"
              }, null, 40, _hoisted_27),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('workouts.TO')), 1),
              _createElementVNode("input", {
                min: "0",
                name: "ave_speed_to",
                value: _ctx.$route.query.ave_speed_to,
                onChange: handleFilterChange,
                step: "0.1",
                type: "number"
              }, null, 40, _hoisted_28)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('workouts.MAX_SPEED')) + " (" + _toDisplayString(_unref(toUnit)) + "/h): ", 1),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("input", {
                min: "0",
                name: "max_speed_from",
                value: _ctx.$route.query.max_speed_from,
                onChange: handleFilterChange,
                step: "0.1",
                type: "number"
              }, null, 40, _hoisted_32),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('workouts.TO')), 1),
              _createElementVNode("input", {
                min: "0",
                name: "max_speed_to",
                value: _ctx.$route.query.max_speed_to,
                onChange: handleFilterChange,
                step: "0.1",
                type: "number"
              }, null, 40, _hoisted_33)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("button", {
          class: "confirm",
          onClick: onFilter
        }, _toDisplayString(_ctx.$t('buttons.FILTER')), 1),
        _createElementVNode("button", {
          class: "confirm",
          onClick: onClearFilter
        }, _toDisplayString(_ctx.$t('buttons.CLEAR_FILTER')), 1)
      ])
    ])
  ]))
}
}

})